import PropTypes from "prop-types"
import { useState } from "react"
import { Grid, Typography, Box } from "@mui/material"
import { cloudinaryFull } from "../../../../../../utils/formatCloudinary"

OrderItemsMobileView.propTypes = {
  orderItems: PropTypes.array,
  handleRowSelection: PropTypes.func,
};
export default function OrderItemsMobileView({ orderItems, handleRowSelection }) {
  const [selectedIds, setSelectedIds] = useState([]);
  
  const textOverflowStyle = {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: 'block',
    width: '100%',
  }

  return <Grid direction="row" container spacing={1} sx={{flexWrap: 'wrap'}}>
    {orderItems.map(item =>
      <Grid item key={item.id}>
        <Box
          sx={{
            p: 1,
            border: (theme) => `${selectedIds?.includes(item.id) ? 2 : 1}px solid ${selectedIds?.includes(item.id) ? theme.palette.primary.main : `black`}`,
            borderRadius: 1,
            width: 100,
            height: '100%',
            cursor: 'pointer',
            backgroundColor: selectedIds?.includes(item.id) ? '#f7feecff' : '#ffffff',
          }}
          onClick={() => {
            const updatedSelectedIds = selectedIds?.includes(item.id)
              ? selectedIds.filter(id => id !== item.id)
              : [...(selectedIds || []), item.id];
            setSelectedIds(updatedSelectedIds);
            handleRowSelection(updatedSelectedIds);
          }}>
          <Box sx={{height: 65}}>
            <Box
              component="img"
              alt="attachment"
              src={
                item?.pictures?.length
                  ? cloudinaryFull(item.pictures[0])
                  : cloudinaryFull(
                      'https://res.cloudinary.com/agoraserv/image/upload/v1738258682/No%20Image%20Animation.gif'
                    )
              }
              sx={{ maxHeight: '100%', maxWidth: '100%', objectFit: 'contain', display: 'block' }}
            />
          </Box>
          <Typography variant="subtitle2" sx={textOverflowStyle}>
            {item.description}
          </Typography>
          <Typography variant="caption" sx={textOverflowStyle}>
            Quantity: {item.quantity}
          </Typography>
          <Typography variant="caption" sx={textOverflowStyle}>
            {item.status}
          </Typography>
        </Box>
      </Grid>
    )}
  </Grid>
}